/**
 * 案例数据（在此填写/新增案例）
 * type 取值: miniProgram / app / website / system
 * cover 为图片描述词（英文），页面将自动生成为封面图
 */
export default [
  {
    id: 1,
    title: '云上湘遇餐饮连锁点餐小程序',
    type: 'miniProgram',
    typeName: '小程序开发',
    cover:
      'modern restaurant ordering mini program UI mockup on smartphone screen, elegant warm-toned food photography, digital menu cards, clean app interface design, professional presentation, high quality',
    summary: '为连锁湘菜品牌定制点餐+会员小程序，上线 3 个月会员突破 5 万。',
    client: '云上湘遇餐饮管理有限公司',
    industry: '餐饮连锁',
    duration: '45 天',
    tech: ['微信小程序', 'uni-app', 'Vue3', 'Node.js'],
    background:
      '客户拥有 12 家直营门店，高峰期排队严重、会员数据分散，缺少线上经营抓手。急需一套覆盖堂食点餐、外卖自取、会员营销的小程序系统，统一管理多门店经营数据。',
    solution:
      '搭建点餐+会员一体化小程序：扫码点餐、预点单、外卖自取；会员储值、积分、优惠券、拼团裂变等营销工具；总部后台统一管理菜品、门店、订单与经营报表。',
    highlights: ['扫码点餐平均排队时长缩短 60%', '会员复购率提升 38%', '多门店数据实时归集'],
    result: '上线 3 个月，注册会员突破 5 万人，线上订单占比从 12% 提升至 46%。'
  },
  {
    id: 2,
    title: '鲜优选生鲜零售商城小程序',
    type: 'miniProgram',
    typeName: '小程序开发',
    cover:
      'fresh grocery e-commerce mini program interface on mobile phone, fresh fruits vegetables product cards, green accent color, clean modern shopping UI design, professional mockup',
    summary: '社区生鲜电商小程序，支持同城配送+自提点模式，日活稳定在 1.2 万。',
    client: '鲜优选社区电商',
    industry: '生鲜电商',
    duration: '60 天',
    tech: ['微信小程序', 'Vue3', 'Spring Boot', 'MySQL'],
    background:
      '传统社区生鲜门店受电商冲击，客户希望自建线上商城，打通 30 个社区自提点与同城配送，形成线上下单、就近自提的履约网络。',
    solution:
      '开发生鲜商城小程序：秒杀、限时购、拼团等营销组件；自提点地图选点与分时段自提；同城配送接单调度；供应链后台管理进销存与损耗。',
    highlights: ['30 个自提点线上协同', '次日达履约准时率 98%', '损耗率下降 21%'],
    result: '上线一年累计订单 30 万+，日活稳定 1.2 万，坪效提升约 35%。'
  },
  {
    id: 3,
    title: '星脉智能家居控制 App',
    type: 'app',
    typeName: 'App 开发',
    cover:
      'smart home control app interface on two smartphones, modern dark theme dashboard with device cards, smart bulbs and scenes, sleek tech design, professional mobile UI mockup',
    summary: '面向智能家居场景的物联控制 App，已接入 40+ 品类设备，MAU 破 20 万。',
    client: '星脉智能科技有限公司',
    industry: '智能硬件',
    duration: '90 天',
    tech: ['iOS', 'Android', 'Flutter', 'MQTT'],
    background:
      '硬件厂商星脉需要一款统一控制 App 来管理旗下 40 多种智能设备，同时支撑电商售卖后的激活、配网与固件升级，保障用户体验。',
    solution:
      '采用 Flutter 跨端方案快速覆盖双端：设备配网、场景联动、定时任务、语音控制；OTA 固件升级与异常告警；内置商城与服务工单入口。',
    highlights: ['40+ 品类设备统一接入', '配网成功率提升至 96%', '双端一次开发复用'],
    result: 'App 累计下载 60 万+，月活突破 20 万，硬件复购率提升 27%。'
  },
  {
    id: 4,
    title: '燃动力健身社区 App',
    type: 'app',
    typeName: 'App 开发',
    cover:
      'fitness training community app interface on smartphone, workout plan cards, activity rings and progress charts, vibrant energetic color scheme, modern sporty mobile UI design mockup',
    summary: '健身课程+运动社交 App，含直播课与打卡挑战，7 日留存达 34%。',
    client: '燃动力网络科技',
    industry: '运动健康',
    duration: '75 天',
    tech: ['iOS', 'Android', 'React Native', 'WebRTC'],
    background:
      '客户从线下健身房转型线上，需要一款集课程训练、直播互动、社区打卡于一体的 App，以低成本获取并留存用户。',
    solution:
      '搭建训练内容体系（录播课+直播课）；运动数据同步与成就徽章体系；社区发帖、打卡挑战赛与好友排行；会员订阅与课程分销。',
    highlights: ['直播课并发支撑 5000+', '打卡活动参与率 41%', '订阅转化率 8.6%'],
    result: '上线半年注册用户 45 万，7 日留存 34%，付费会员超 3.8 万人。'
  },
  {
    id: 5,
    title: '恒达集团品牌官网',
    type: 'website',
    typeName: '网站开发',
    cover:
      'corporate brand website homepage displayed on laptop screen, modern business design with deep blue hero section, clean layout, professional enterprise web design mockup',
    summary: '制造业集团高端品牌官网，SEO 关键词排名进入首页前五，询盘量提升 3 倍。',
    client: '恒达集团股份有限公司',
    industry: '制造集团',
    duration: '30 天',
    tech: ['Vue3', 'Vite', 'Node.js', 'SEO'],
    background:
      '恒达集团旧官网十年未改版，品牌形象老化，海外客户通过官网了解企业产品的主要入口亟需重建，同时要求兼容中英文双语。',
    solution:
      '重塑品牌视觉与信息架构：企业形象、产品中心、解决方案、新闻动态、加入我们五大板块；中英文双语站点；SEO 结构化数据与性能优化。',
    highlights: ['首屏加载 < 1.2s', '中英双语自动适配', '询盘量提升 3 倍'],
    result: '上线半年官网自然流量提升 220%，B 端询盘数量翻三倍。'
  },
  {
    id: 6,
    title: '普沃 B2B 工业品商城',
    type: 'website',
    typeName: '网站开发',
    cover:
      'B2B industrial products e-commerce website on laptop, product grid catalog with filters, professional business shopping platform interface, modern web design mockup',
    summary: '工业品在线采购商城，对接 ERP 库存系统，月交易额突破 5000 万。',
    client: '普沃供应链管理有限公司',
    industry: '工业电商',
    duration: '80 天',
    tech: ['Vue3', 'Element Plus', 'Spring Cloud', 'Elasticsearch'],
    background:
      '普沃经营数万 SKU 的工业品，采购方与供应商信息不对称，需要一套面向企业客户的多供应商采购商城，并与内部 ERP 库存打通。',
    solution:
      '搭建多商家入驻的 B2B 采购平台：品类导航与高级检索；阶梯价、账期、合同下单等 B 端交易能力；与 ERP 库存实时同步；供应商后台自主上架。',
    highlights: ['5 万+ SKU 检索秒级响应', '账期结算与对账自动化', 'ERP 库存实时同步'],
    result: '入驻供应商 300+，月交易额突破 5000 万，采购人效提升 60%。'
  },
  {
    id: 7,
    title: '智造云 ERP 管理系统',
    type: 'system',
    typeName: '系统开发',
    cover:
      'ERP management system dashboard on desktop monitor, production order kanban charts and data tables, professional enterprise software interface, dark blue tech design, high quality mockup',
    summary: '中小制造企业一站式 ERP，覆盖订单/采购/生产/仓储全链路，上线 8 个月。',
    client: '智造云信息科技',
    industry: '生产制造',
    duration: '120 天',
    tech: ['Vue3', 'Vite', 'Java', 'PostgreSQL'],
    background:
      '客户服务 60+ 家中小制造企业，需要一套轻量但覆盖全链路的 ERP，替代碎片化的 Excel 管理，解决订单交期失控与库存积压问题。',
    solution:
      '开发订单、采购、生产、仓储、财务五大模块：MRP 物料需求运算；车间工序报工与进度看板；条码出入库与批次追溯；经营驾驶舱报表。',
    highlights: ['订单交付准时率 95%+', '库存周转率提升 42%', '60+ 企业云端多租户'],
    result: '上线 8 个月服务 60+ 制造企业，平均交付周期缩短 30%，库存积压下降 25%。'
  },
  {
    id: 8,
    title: '城市智慧水务数据可视化大屏',
    type: 'system',
    typeName: '系统开发',
    cover:
      'smart city water monitoring data visualization big screen dashboard, world map with pipelines and charts, glowing blue tech interface, dark background, large screen UI design mockup',
    summary: '水务集团调度中心可视化大屏，接入 3 万+ 传感器实时数据，调度效率提升 50%。',
    client: '清源水务集团',
    industry: '公共服务',
    duration: '70 天',
    tech: ['Vue3', 'ECharts', 'WebSocket', 'Flink'],
    background:
      '水务集团下辖 12 座水厂、数万监测点，数据分散在多个系统。调度中心需要一张"会说话"的大屏，实时掌握全网供水、水质与管网状态。',
    solution:
      '建设可视化大屏指挥中心：实时流量、水压、水质趋势图；管网 GIS 地图与爆管预警；片区用水热力分析；对接水厂 SCADA 与抄表系统。',
    highlights: ['3 万+ 点位实时接入', '爆管预警准确率 90%+', '10s 内全链路数据刷新'],
    result: '调度人员从 15 人精简到 8 人，管网事故响应时间缩短 50%，年节约水损 300 万吨。'
  }
]
